import {Button} from '@mantine/core';
import classes from './button.module.css';

export const ButtonTheme = Button.extend({
  classNames: classes,
  defaultProps: {
    styles: {
      label: {
        fontSize: '12px',
        fontWeight: 'normal',
      },
    }
  }
});